module.exports = __webpack_public_path__ + "img/102052.c0376f78.png";